import React from 'react';
import StageBackground from '../../DeviationBackground/StageBackground';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import s from './CommissionStage.scss';
var CommissionStage = function (_a) {
    var deviation = _a.deviation;
    return (React.createElement("div", { className: s['root'], "data-hook": BiDataHook.DEVIATION_ART_STAGE },
        React.createElement(StageBackground, { deviation: deviation }),
        React.createElement(DeviationFullView, { deviation: deviation }),
        React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] })));
};
CommissionStage.displayName = 'CommissionStage';
export default CommissionStage;
//# sourceMappingURL=CommissionStage.js.map